import { render, staticRenderFns } from "./RegisterModule.vue?vue&type=template&id=c3dc9be8&scoped=true&"
import script from "./RegisterModule.vue?vue&type=script&lang=js&"
export * from "./RegisterModule.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModule.vue?vue&type=style&index=0&id=c3dc9be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3dc9be8",
  null
  
)

export default component.exports